var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "live-header", style: _vm.bgStyle },
    [
      _c("header", { staticClass: "header" }, [
        _c("div", { staticClass: "header-left" }, [
          _c("img", {
            staticClass: "logo",
            attrs: { src: require("@/assets/img/live/logo.png") }
          }),
          _vm._v(" "),
          _c("ul", { staticClass: "left-nav" }, [
            _c(
              "li",
              {
                class: [["/index"].includes(_vm.currPath) ? "active" : ""],
                on: {
                  click: function($event) {
                    return _vm.goTo("/index")
                  }
                }
              },
              [_vm._v("首页")]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: [
                  ["/video", "/stream"].includes(_vm.currPath) ? "active" : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.goTo("/stream")
                  }
                }
              },
              [_vm._v("直播")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "header-right" }, [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("Input", {
                staticClass: "search-input",
                staticStyle: { display: "none" },
                attrs: { placeholder: "", maxlength: "15" },
                scopedSlots: _vm._u([
                  {
                    key: "suffix",
                    fn: function() {
                      return [
                        _c("Icon", {
                          attrs: { type: "ios-search", size: "20" }
                        })
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "userinfo" }, [
            !_vm.isLogin
              ? _c(
                  "div",
                  {
                    staticClass: "info-item",
                    on: {
                      click: function($event) {
                        return _vm.$login.showLogin()
                      }
                    }
                  },
                  [
                    _c("Icon", {
                      attrs: { type: "ios-contact-outline", size: "20" }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("登录")])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isLogin
              ? _c(
                  "div",
                  { staticClass: "info-item-avatar" },
                  [
                    !_vm.wcnCfg
                      ? [
                          _c(
                            "Dropdown",
                            { on: { "on-click": _vm.handelDropMenu } },
                            [
                              _c("img", {
                                staticClass: "user-avatar",
                                attrs: { src: _vm.user.avatar }
                              }),
                              _vm._v(" "),
                              _c(
                                "DropdownMenu",
                                { attrs: { slot: "list" }, slot: "list" },
                                [
                                  _c(
                                    "DropdownItem",
                                    { attrs: { name: "chonzhi" } },
                                    [_vm._v("在线充值")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "DropdownItem",
                                    { attrs: { name: "user" } },
                                    [_vm._v("个人中心")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "DropdownItem",
                                    { attrs: { name: "logout" } },
                                    [_vm._v("退出登录")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : [
                          _c("img", {
                            staticClass: "user-avatar",
                            attrs: { src: _vm.user.avatar }
                          })
                        ]
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isLogin
              ? _c(
                  "span",
                  {
                    staticStyle: { margin: "-5px 0 0 20px", cursor: "pointer" },
                    on: { click: _vm.wcnAction }
                  },
                  [
                    _vm._v("未成年保护"),
                    _c(
                      "p",
                      {
                        class: [!_vm.wcnCfg ? "t-red" : "t-green"],
                        staticStyle: {
                          "font-size": "10px",
                          margin: "1px 0 0 0"
                        }
                      },
                      [_vm._v(_vm._s(!_vm.wcnCfg ? "未开启" : "已开启"))]
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("setA", { ref: "setARef" }),
      _vm._v(" "),
      _c("setC", { ref: "setCRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-577a5848", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-577a5848","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/live/LiveHeader.vue
// module id = null
// module chunks = 